import { PRESET } from "../../lib/lighting-presets";

export default function MezzanineLights() {
	const p = PRESET;

	return (
		<>
			{/* p.mezzanine.lights.map((l, i) => (
				<pointLight
					key={i}
					position={l.position}
					intensity={l.intensity}
					distance={l.distance}
					color={l.color}
				/>
			)) */}
		</>
	);
}
